import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
interface DisclosureNoticeProps {
  className: string;
}
export const DisclosureNotice = t0 => {
  "use memo";

  const $ = _c(7);
  const {
    className
  } = t0;
  const t = useTranslations("newsletters");
  let t1;
  if ($[0] !== t) {
    t1 = t("disclosure_notice_html");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      __html: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = <div className={className} dangerouslySetInnerHTML={t2} />;
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};